// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ActiveState, Jsonld, SeoProps } from "@bg/App/Widgets/SearchEngineOptimization/SearchEngineOptimization";

/**
 * Activate structure based on condition
 *
 * @param SeoProps
 * @returns ActiveState
 */
const activate = ({ state, fields }: SeoProps): ActiveState => {
    return true;
};

/**
 * Build the structured data
 *
 * @param SeoProps
 * @returns Jsonld
 */
const json = ({ state, fields, url }: SeoProps): Jsonld => {
    return {
        "@context": "https://schema.org",
        "@type": "Organization",
        url,
        name: fields.organizationName || state.context.website.name,
        description: fields.description,
        telephone: fields.telephone,
        email: fields.email,
        faxNumber: fields.faxNumber,

        address: {
            "@type": "PostalAddress",
            addressCountry: fields.addressCountry,
            addressLocality: fields.addressLocality,
            addressRegion: fields.addressRegion,
            postalCode: fields.postalCode,
            streetAddress: fields.streetAddress,
        },
        logo: {
            "@type": "ImageObject",
            url: fields.logoUrl,
            name: fields.organizationName || state.context.website.name,
        },
        contactPoint: [
            {
                "@type": "ContactPoint",
                telephone: fields.telephone,
                contactType: "Customer Service",
            },
        ],
        ...(fields?.socialLinks?.length && { sameAs: fields?.socialLinks?.map((item: any) => item.fields.url) }),
    };
};

export default { activate, json };
